import { render } from "./items.vue?vue&type=template&id=177886f6&scoped=true"
import script from "./items.vue?vue&type=script&lang=js"
export * from "./items.vue?vue&type=script&lang=js"

import "./items.vue?vue&type=style&index=0&id=177886f6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177886f6"]])

export default __exports__